import { getDeviceInfo } from "../Upshow";

const x1ModelConfig = {
        activationScreen: {
            isMultiStep: true,
            andMoreText: "& more - now available on Comcast X1 devices.",
            showButtonHelperText: false,
            salesCTAText: "Call EverPass now at",
            salesPhone: `${process.env.REACT_APP_COMCAST_SALES_NUMBER}`,
            onlyAvailableHelper: "EverPass is only available for streaming on X1 devices.",
            coBrandedLogo: "https://cdn.upshow.tv/ui-assets/comcastbusiness-logo.png",
            promoCode: true,
        },
        epg: { scrollBehavior: "auto" },
        inactiveState: {
            contact: "Please contact Charter Support",
            phone: `Phone ${process.env.REACT_APP_COMCAST_HELP_DESK_NUMBER}`,
            email: "",
        },
    }
const MODEL_CONFIG = {
    xumo: {
        activationScreen: {
            isMultiStep: true,
            andMoreText: "& more from EverPass.",
            showButtonHelperText: true,
            salesCTAText: "Call Spectrum Business now at",
            salesPhone: `${process.env.REACT_APP_SPECTRUM_SALES_NUMBER}`,
            onlyAvailableHelper: "",
            coBrandedLogo: "https://cdn.upshow.tv/ui-assets/Spectrum_Logo.svg",
            promoCode: false,
        },
        epg: { scrollBehavior: "auto" },
        inactiveState: {
            contact: "Please contact Charter Support",
            phone: `Phone ${process.env.REACT_APP_SPECTRUM_HELP_DESK_NUMBER}`,
            email: "",
        },
    },
    xi6: x1ModelConfig,
    xg2v2: { ...x1ModelConfig, epg: { customScrollBehavior: true } },
    xid: { ...x1ModelConfig, epg: { customScrollBehavior: true } },
    default: {
        activationScreen: {
            isMultiStep: false,
            andMoreText: "",
            showButtonHelperText: false,
            salesCTAText: "",
            salesPhone: "",
            onlyAvailableHelper: "",
            coBrandedLogo: "",
            promoCode: false,
        },
        epg: { scrollBehavior: "smooth" },
        inactiveState: {
            contact: "Please contact EverPass Support",
            phone: `Phone 855-787-7469`,
            email: `Email support@everpass.com`,
        },
    },
};

const MAKE_CONFIG = {
    comcast: {
        emptyState: { imageFallback: true },
        liveEventState: { videoPlaceholder: false },
        loadingState: { image: true },
    },
    default: {
        emptyState: { imageFallback: false },
        liveEventState: { videoPlaceholder: true },
        loadingState: { image: false },
    },
};

export const getModelConfig = () => {
    const model = getDeviceInfo().model.toLowerCase();
    return MODEL_CONFIG[model] || MODEL_CONFIG.default;
};

export const getMakeConfig = () => {
    const make = getDeviceInfo().make.toLowerCase();
    return MAKE_CONFIG[make] || MAKE_CONFIG.default;
};

export const getModel = () => {
    return getDeviceInfo().model.toLowerCase();
}

export const getMake = () => {
    return getDeviceInfo().make.toLowerCase();
}
